// src/lib/courses-gate.ts
// Single source of truth for the admin-controlled flag that hides Kursus Mandiri
// until launch. Four surfaces must agree on it — the courses layout, the course
// detail metadata, the homepage and the sitemap — and a typo in any one of them
// silently un-gates that surface, so never re-type the key.
import { settingsApi } from '@/lib/api';

export const COURSES_COMING_SOON_KEY = 'courses.comingSoon.enabled';

/** Fail open: a missing or errored setting means NOT gated. */
export function isCoursesComingSoonIn(settings: Record<string, unknown>): boolean {
  return Boolean(settings[COURSES_COMING_SOON_KEY]);
}

/**
 * Next dedupes identical fetch() calls within a single request, so calling this
 * from both a layout and the page it wraps costs one round-trip, not two.
 */
export async function isCoursesComingSoon(): Promise<boolean> {
  const settings = await settingsApi.getPublic().catch(() => ({}) as Record<string, unknown>);
  return isCoursesComingSoonIn(settings);
}
